<template>
  <div class="cart orderList" id="mypage-order-list-page">
    <h1 class="boxTitle mb15 notranslate">
      <router-link v-if="isPackage"
        :to="{ name: 'mypackage' }"
        class="btnMypackage">
        마이패키지
      </router-link>
      {{locale.order_list}}
    </h1>
    <div v-if="list.length" ref="mypageList" class="list" >
      <OrderListItem
        v-for="item in list"
        :key="item.order_id"
        :itemList="item"
        :locale="locale"
        :lang="lang" />
      <button
        v-if="next"
        type="button"
        ref="btnMore"
        class="btn btnFull btnRound btnWhite"
        @click="getOrderHistory">
        {{ locale.viewmore }}
      </button>
    </div>
    <div v-else class="noData notranslate">{{locale.order_nodata}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrderListItem from '@/components/Mypage/OrderListItem'

export default {
  name: 'OrderList',
  props: [
    // 'lang', // props로 받는데 어디서 끊어지는지 이유를 모르겠음 (setLink를 통해 이동된 경우에 발생)
    'locale'
  ],
  components: {
    OrderListItem
  },
  computed: {
    ...mapGetters({
      metaInfo: 'authentication/getMetaInfo',
      defaultBtnStyle: 'common/getDefaultBtnStyle'
    }),
    isPackage () {
      return this.$route.params.package
    },
    setting () {
      const responsive = this.responsive
      const settingData = this.$store.getters['common/getSetting']
      let data = Object.assign({}, settingData)
      return data
    },
    translateType () {
      const lang = this.$route.params.ln
      const langData = lang && this.setting.lang.info.find(l => l.c === lang) ? this.setting.lang.usableList : null
      const type = langData && langData.find(x => x.c === lang) ? (langData.find(x => x.c === lang).t ? 'manual' : 'auto') : 'manual'
      return type
    },
    lang () {
      const translate = this.translateType
      const autoTranslate = translate === 'auto'
      const defaultLang = this.setting.lang ? this.setting.lang.default : 'en'
      const paramsLang = this.$route.params.ln
      return autoTranslate ? defaultLang : paramsLang
    },
  },
  async mounted () {
    await this.getKey()
    await this.getOrderHistory()
  },
  data () {
    return {
      list: [],
      moreCount: 0,
      next: null,
      space: this.$store.state.authentication.space,
      key: this.$store.state.authentication.k
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'orderList'
      })
    },
    async getOrderHistory () {
      this.$store.commit('loading', true)
      const next = this.next
      const mypageType = this.$route.name.replace('my', '').toLowerCase()
      const guestPackages = (this.guestUserInfo && this.guestUserInfo.packages) || []
      const data = {
        mypageType: mypageType,
        paging: {
          limit: 30,
          ...next && {
            next: next
          }
        },
        ...this.isPackage && {
          filter: {
            isPackage: true,
            ...guestPackages.length > 0 && {
              guestPackages: guestPackages
            }
          }
        }
      }
      const history = await this.$store.dispatch('guest/getMypageHistory', data)
      if (history && history.items) {
        this.list = this.list.map(x => {
          return {
            ...x,
            firstItem: false
          }
        }).concat(history.items.map((x, i) => {
          return {
            ...x,
            firstItem: i === 0 // 새로 불러온 첫 아이템으로 스크롤 하기 위한 flag
          }
        }))
      }
      this.$store.commit('loading', false)
      this.next = (history && history.next) || null
      this.scrollList()
      return history
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    init () {
      this.track()
    },
    scrollList () {
      this.$nextTick(() => {
        const list = this.$refs.mypageList
        const firstItem = document.querySelector('.firstItem')
        if (firstItem && this.moreCount > 0) {
          const top = firstItem.offsetTop
          const height = firstItem.offsetHeight
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          })
        }
        this.moreCount += 1
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 90px 0;
  text-align: center;
}
</style>
